import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('Modal', {
  OPEN_MODAL: null,
  CLOSE_MODAL: null
});
